module.exports = __webpack_public_path__ + "static/media/playlist.d5dc889d.png";